import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import DateFormatter from 'Common/Components/DateFormatter';
import {
  Table, HeaderCell, Cell, Empty
} from './styled';

const PLACEHOLDER = '—';

const ToolsHistoryTable = ({ items }) => {
  const intl = useIntl();

  if (!items.length) return <Empty>{PLACEHOLDER}</Empty>;

  return (
    <Table>
      <thead>
        <tr>
          <HeaderCell>{intl.formatMessage({ id: 'command.toolsHistory.tool' })}</HeaderCell>
          <HeaderCell>{intl.formatMessage({ id: 'command.toolsHistory.commandId' })}</HeaderCell>
          <HeaderCell>{intl.formatMessage({ id: 'command.toolsHistory.date' })}</HeaderCell>
        </tr>
      </thead>
      <tbody>
        {items.map((item, index) => (
          <tr key={ `tools_history_${item.commandId}_${index}` }>
            <Cell>{item.tool || PLACEHOLDER}</Cell>
            <Cell>{item.commandId ?? PLACEHOLDER}</Cell>
            <Cell><DateFormatter date={ item.createDate } /></Cell>
          </tr>
        ))}
      </tbody>
    </Table>
  );
};

ToolsHistoryTable.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    tool: PropTypes.string,
    commandId: PropTypes.number,
    createDate: PropTypes.string
  })).isRequired
};

export default ToolsHistoryTable;
